export const loopIterator = <T>(iterator: Iterator<T>, callback: (item: T, index: number) => void) => {
    let index = 0;
    let item = iterator.next();

    while (!item.done) {
        callback(item.value, index);

        index++;
        item = iterator.next();
    }
};

export const loopList = <T>(list: T[], callback: (item: T, index: number) => void) => {
    loopIterator(list.values(), callback);
};
